import SAPLogin from "../../components/admin/login/SAPLogin";

const Login = () => {
  return (
    <>
      <SAPLogin />
    </>
  );
};

export default Login;
